import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  searchReducer,
  sortReducer,
} from "../redux/features/filter/filterSlice";

export default function SearchBar() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  const handleSearch = (e) => {
    setSearch(e.target.value.trim());
    dispatch(searchReducer(search));
  };

  return (
    <div className="flex gap-4">
      <div className="search-field group flex-1">
        <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
        <input
          type="text"
          placeholder="Search Job"
          className="search-input"
          id="lws-searchJob"
          onKeyUp={handleSearch}
          onSelect={handleSearch}
          onChange={handleSearch}
        />
      </div>

      <select
        id="lws-sort"
        name="sort"
        autoComplete="sort"
        className="flex-1"
        onChange={(e) => dispatch(sortReducer(e.target.value))}
      >
        <option>Default</option>
        <option>Salary (High to Low)</option>
        <option>Salary (Low to High)</option>
        <option>Date (Latest to Oldest)</option>
        <option>Date (Oldest to Latest)</option>
      </select>
    </div>
  );
}
